import React from 'react';
import InfoHelper from '../InfoHelper';

const Kpi_gadget_header = (props) => {
    return(
        <div className="kpi_gadget_header">
            <div>
              <span className="count_top">{props.label}</span>
              {props.helpText ? <InfoHelper text={props.helpText} maxWidth={280} /> : null}
              <span className={props.class}>{props.value}</span>
            </div>
        </div>
    );
}

export default Kpi_gadget_header;
